module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.c64fc9b4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-MediumItalic.woff2
// module id = 522
// module chunks = 0